import { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";

import {
	API_URL,
	scroll,
	fmtCurrency,
	isFieldError,
	getValFromLS,
	setValToLS,
	isTopSponsor,
} from "../helpers";

import Hdg from "../components/Hdg";
import Alert from "../components/Alert";
import Input from "../components/Input";
import Select from "../components/Select";
import Checkbox from "../components/Checkbox";
import Radios from "../components/Radios";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

import Steps from "./Steps";
import AddressUsFields from "./AddressUsFields";
import AddressCaFields from "./AddressCaFields";
import AddressIntlFields from "./AddressIntlFields";

import BillingAddonTickets from "./BillingAddonTickets";

const RegBilling = () => {
	const [order, setOrder] = useState({});
	const [addOnDonationData] = useState({
		donation: {
			id: "donation",
			name: "Donation",
			bullets: [],
			amt: 0,
			golf: 0,
			welcome: 0,
			gift: 0,
		},
	});
	const [addOnDonation, setAddOnDonation] = useState({});
	const [addOnData, setAddOnData] = useState({});
	const [addOn, setAddOn] = useState({});
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({
		qty: 1,
		addressType: "us",
		thu: "0",
		fri: "0",
		sat: "0",
		sun: "0",
	});
	const [msg, setMsg] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const history = useHistory();
	const formElement = useRef();
	const formElement2 = useRef();
	const formElement3 = useRef();

	let total = JSON.parse(getValFromLS("order", true)).level.amt || 0;

	useEffect(() => {
		const init = async () => {
			if (getValFromLS("auth", true) && getValFromLS("order", true)) {
				const authFromLS = JSON.parse(getValFromLS("auth", true));

				const url = new URL(`${API_URL}/registrationBillingInit`);
				const params = {
					id: authFromLS.id,
				};
				url.search = new URLSearchParams(params);

				try {
					const response = await fetch(url, {
						method: "GET",
						cache: "no-store",
					});
					const json = await response.json();
					if (json && json.resp === 1) {
						const orderFromLS = JSON.parse(getValFromLS("order", true));

						const newOrder = {
							level: orderFromLS.level,
							addons: [],
						};

						setOrder(newOrder);
						setValToLS("order", JSON.stringify(newOrder), true);
						setAddOnData(json.addons);
						handleUpdate("email", authFromLS.email);
						setAlert({});
						scroll();
					}
				} catch (error) {
					setAlert({
						type: "error",
						text: "An error has occurred.",
					});
				}
			} else {
				history.push("/registration");
			}
		};

		init();

		// eslint-disable-next-line
	}, []);

	const handleUpdate = (name, value) => {
		if (name === "addonDonation") {
			if (value && !isNaN(value)) {
				const newAddon = addOnDonationData["donation"];
				newAddon.amt = Number(value) * 100;
				setAddOnDonation(newAddon);
			} else {
				setAddOnDonation({});
			}
		} else if (name === "addon") {
			if (value) {
				const newAddon = addOnData[value];
				setAddOn(newAddon);
			} else {
				setAddOn({});
			}
		} else if (name === "qty" && (isNaN(value) || Number(value) < 1)) {
			setNames((names) => ({ ...names, qty: 1 }));
		} else {
			setNames((names) => ({ ...names, [name]: value ? value : "" }));
		}
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/registrationBilling`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			if (key === "twoyear") {
				data.append(key, value ? "1" : "0");
			} else {
				data.append(key, value);
			}
		});
		data.append("order", getValFromLS("order", true));
		data.append("auth", getValFromLS("auth", true));

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				let orderFromLS = JSON.parse(getValFromLS("order", true));
				orderFromLS.payment = "";
				orderFromLS.orderId = json.orderId;
				orderFromLS.billto = {
					prefix: names.prefix,
					fname: names.fname,
					lname: names.lname,
					title: names.title,
					organization: names.organization,
					addressType: names.addressType,
					address: names.address,
					address2: names.address2,
					city: names.city,
					st: names.st,
					zip: names.zip,
					country:
						names.addressType === "us"
							? "US"
							: names.addressType === "ca"
							? "CA"
							: names.country,
				};
				setValToLS("order", JSON.stringify(orderFromLS), true);

				history.push("/registration/allocations");
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const handleSubmit2 = async (e) => {
		e.preventDefault();

		if (addOn && names.qty && names.qty < 21) {
			let newArray = order.addons;
			newArray.push({
				qty: names.qty,
				...addOn,
			});
			const newOrder = { ...order, addons: newArray };

			setOrder((order) => newOrder);
			setValToLS("order", JSON.stringify(newOrder), true);
			formElement2.current.addon.selectedIndex = 0;
			formElement2.current.qty.value = 1;
			setNames((names) => ({ ...names, qty: 1 }));
			setAddOn({});
		}
	};

	const handleRemove = (index) => {
		let newArray = order.addons;
		newArray.splice(index, 1);

		const newOrder = { ...order, addons: newArray };
		setOrder((order) => newOrder);
		setValToLS("order", JSON.stringify(newOrder), true);
	};

	const handleSubmit3 = async (e) => {
		e.preventDefault();

		if (addOnDonation) {
			let newArray = order.addons;
			newArray.push({
				qty: 1,
				...addOnDonation,
			});
			const newOrder = { ...order, addons: newArray };

			setOrder((order) => newOrder);
			setValToLS("order", JSON.stringify(newOrder), true);
			formElement3.current.addonDonation.value = "";
			setNames((names) => ({ ...names, qty: 1 }));
			setAddOnDonation({});
		}
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div id="left-column">
						<Hdg section="Sponsor Registration" />
						<div className="blocktext step">
							<h1 style={{ marginBottom: "0" }}>2</h1>
							<div>
								<p>
									Please enter your billing contact infomation to continue. If
									you have any questions, please email{" "}
									<a href="mailto:ValeroBFC@valero.com">ValeroBFC@valero.com</a>
									.
								</p>
							</div>
						</div>

						<table
							className="approved"
							style={{ marginTop: "25px", marginBottom: "25px" }}
						>
							<thead>
								<tr>
									<th className="left" style={{ width: "75%" }}>
										{order.addons.length > 0
											? "Sponsor Level / Add-Ons"
											: "Sponsor Level"}
									</th>
									<th>Amount</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td className="left">
										<p
											style={{
												margin: "0",
												marginTop: "5px",
												fontSize: "1.1rem",
											}}
										>
											{order.level.name}
										</p>
										<ul
											style={{
												marginTop: "5px",
												marginBottom: "0",
											}}
										>
											{order.level.golf > 0 && (
												<li>{`${order.level.golf} Golf or Sporting Clays Playing Spots`}</li>
											)}
											{order.level.welcome > 0 && (
												<li>{`${order.level.welcome} Welcome Party Invites`}</li>
											)}
											{order.level.gift > 0 && (
												<li>{`${order.level.gift} Gift Packages`}</li>
											)}
										</ul>
									</td>
									<td className="right">
										{fmtCurrency(order.level.amt / 100)}
									</td>
								</tr>

								{order.addons.map((addon, index) => {
									total = total + addon.qty * addon.amt;

									return (
										<tr key={index}>
											<td className="left">
												<div className="addon-item-container">
													<div>
														<p
															style={{
																margin: "0",
																marginTop: "5px",
																fontSize: "1.1rem",
															}}
														>
															{`${addon.name}`}
														</p>
														<p style={{ marginTop: "0", marginBottom: "0" }}>
															<small>{`${addon.qty} @ ${fmtCurrency(
																addon.amt / 100,
															)} ea.`}</small>
														</p>
														<ul
															style={{
																marginTop: "5px",
																marginBottom: "0",
															}}
														>
															{addon.bullets.map((bullet, index) => {
																return <li key={index + 10}>{bullet}</li>;
															})}
														</ul>
													</div>

													<button
														type="button"
														onClick={() => handleRemove(index)}
														className="naked"
													>
														<i className="fa fa-trash fa-lg error" />
													</button>
												</div>
											</td>
											<td className="right">
												{fmtCurrency((addon.qty * addon.amt) / 100)}
											</td>
										</tr>
									);
								})}
							</tbody>
							<tfoot>
								<tr>
									<th className="right" style={{ paddingRight: "10px" }}>
										TOTAL
									</th>
									<th className="right">{fmtCurrency(total / 100)}</th>
								</tr>
							</tfoot>
						</table>

						{isTopSponsor(order.level.id) && (
							<form
								ref={formElement2}
								method="post"
								action="/"
								onSubmit={(e) => handleSubmit2(e)}
								className="well"
							>
								<h3 style={{ marginTop: "0" }}>Package Add-Ons</h3>

								<div className="form-group">
									<Select
										name="addon"
										label="Select Add-On"
										reqd={true}
										value={""}
										options={[
											{ id: "", name: "--" },
											{
												id: "tickets",
												name: `${addOnData.tickets.name} (up to ${
													addOnData.tickets[order.level.id]
												})`,
											},
											{
												id: "welcome",
												name: `${addOnData.welcome.name} (up to ${
													addOnData.tickets[order.level.id]
												})`,
											},
										]}
										update={handleUpdate}
										error={isFieldError(errors, "addon")}
									/>

									<Input
										type="number"
										name="qty"
										label="Quantity"
										reqd={true}
										value={names.qty}
										autocomplete="qty"
										update={handleUpdate}
										errors={errors}
									/>
								</div>

								{addOn.name && (
									<table
										className="approved"
										style={{ marginTop: "25px", marginBottom: "5px" }}
									>
										<thead>
											<tr>
												<th className="center" style={{ width: "10%" }}>
													Qty
												</th>
												<th className="left">Item</th>

												<th style={{ width: "20%" }}>Total</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td className="center">{names.qty}</td>
												<td className="left">
													<p
														style={{
															margin: "0",
														}}
													>
														{`${addOn.name} - ${fmtCurrency(
															addOn.amt / 100,
														)} ea.`}
													</p>
													<ul
														style={{
															margintop: "0",
															marginBottom: "0",
														}}
													>
														{addOn.bullets.map((bullet, index) => {
															return <li key={index}>{bullet}</li>;
														})}
													</ul>
												</td>

												<td className="right">
													{fmtCurrency((names.qty * addOn.amt) / 100)}
												</td>
											</tr>
										</tbody>
									</table>
								)}

								<div
									style={{
										marginTop: "20px",
										display: "flex",
										justifyContent: "center",
									}}
								>
									<Submit submit="Add Selected to Package" />
								</div>
							</form>
						)}

						<form
							ref={formElement3}
							method="post"
							action="/"
							onSubmit={(e) => handleSubmit3(e)}
							className="well"
						>
							<h3 style={{ marginTop: "0" }}>ADD A DONATION</h3>

							<div className="form-group">
								<Input
									name="addonDonation"
									label="Enter Donation Amount"
									reqd={true}
									value={""}
									update={handleUpdate}
									errors={errors}
									addonIcon="fa-dollar-sign"
								/>

								<div className="empty" />
							</div>

							{addOn.name && (
								<table
									className="approved"
									style={{ marginTop: "25px", marginBottom: "5px" }}
								>
									<thead>
										<tr>
											<th className="center" style={{ width: "10%" }}>
												Qty
											</th>
											<th className="left">Item</th>

											<th style={{ width: "20%" }}>Total</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td className="center">{names.qty}</td>
											<td className="left">
												<p
													style={{
														margin: "0",
													}}
												>
													{`${addOn.name} - ${fmtCurrency(
														addOn.amt / 100,
													)} ea.`}
												</p>
												<ul
													style={{
														margintop: "0",
														marginBottom: "0",
													}}
												>
													{addOn.bullets.map((bullet, index) => {
														return <li key={index}>{bullet}</li>;
													})}
												</ul>
											</td>

											<td className="right">
												{fmtCurrency((names.qty * addOn.amt) / 100)}
											</td>
										</tr>
									</tbody>
								</table>
							)}

							<div
								style={{
									marginTop: "20px",
									display: "flex",
									justifyContent: "center",
								}}
							>
								<Submit submit="Add Donaton to Package" />
							</div>
						</form>

						<form
							ref={formElement}
							method="post"
							action="/"
							onSubmit={(e) => handleSubmit(e)}
							className="well"
						>
							{isTopSponsor(order.level.id) && (
								<h3 style={{ marginTop: "0" }}>New: Multi-year Option</h3>
							)}

							{isTopSponsor(order.level.id) && (
								<div
									className="form-group checkbox"
									style={{ marginTop: "0", marginBottom: "25px" }}
								>
									<Checkbox
										name="twoyear"
										label="For partners interested in a multi-year commitment, please check this box to lock in your rate for 2028"
										checked={false}
										click={handleUpdate}
									/>
								</div>
							)}

							<h3 style={{ marginTop: "0" }}>Bill To</h3>

							<div className="form-group">
								<Select
									name="prefix"
									label="Prefix"
									reqd={true}
									value={""}
									options={[
										{ id: "", name: "--" },
										{ id: "Mr.", name: "Mr." },
										{ id: "Mrs.", name: "Mrs." },
										{ id: "Ms.", name: "Ms." },
										{ id: "Dr.", name: "Dr." },
										{ id: "Other", name: "Other" },
									]}
									update={handleUpdate}
									error={isFieldError(errors, "prefix")}
								/>
								<div className="empty" />
							</div>

							<div className="form-group">
								<Input
									name="fname"
									label="First Name"
									reqd={true}
									value={names.fname || ""}
									autocomplete="given-name"
									update={handleUpdate}
									errors={errors}
								/>
								<Input
									name="lname"
									label="Last Name"
									reqd={true}
									value={names.lname || ""}
									autocomplete="family-name"
									update={handleUpdate}
									errors={errors}
								/>
							</div>

							<div className="form-group">
								<Input
									name="title"
									label="Title"
									reqd={true}
									value={names.title || ""}
									autocomplete="organization-title"
									update={handleUpdate}
									errors={errors}
								/>
								<Input
									name="organization"
									label="Organization"
									reqd={true}
									value={names.organization || ""}
									autocomplete="organization"
									update={handleUpdate}
									errors={errors}
								/>
							</div>

							<div
								className="form-group radios"
								style={{ marginTop: "0", marginBottom: "15px" }}
							>
								<Radios
									label="Select Address Type:"
									reqd={true}
									data={[
										{
											name: "addressType",
											val: "us",
											label: "United States",
										},
										{
											name: "addressType",
											val: "ca",
											label: "Canada",
										},
										{
											name: "addressType",
											val: "intl",
											label: "International",
										},
									]}
									value={names.addressType}
									click={handleUpdate}
								/>
							</div>

							<div className="form-group">
								<Input
									name="address"
									label="Address"
									reqd={true}
									value={names.address || ""}
									autocomplete="off"
									update={handleUpdate}
									errors={errors}
								/>
								<Input
									name="address2"
									label="Address 2"
									reqd={false}
									value={names.address2 || ""}
									autocomplete="off"
									update={handleUpdate}
									errors={errors}
								/>
							</div>

							{names.addressType === "us" ? (
								<AddressUsFields
									city={names.city}
									st={names.st}
									zip={names.zip}
									handleUpdate={handleUpdate}
									errors={errors}
								/>
							) : names.addressType === "ca" ? (
								<AddressCaFields
									city={names.city}
									st={names.st}
									zip={names.zip}
									handleUpdate={handleUpdate}
									errors={errors}
								/>
							) : (
								<AddressIntlFields
									city={names.city}
									zip={names.zip}
									country={names.country}
									handleUpdate={handleUpdate}
									errors={errors}
								/>
							)}

							{ticketAddonsQty(order.addons) > 0 && (
								<BillingAddonTickets
									qty={ticketAddonsQty(order.addons)}
									thu={names.thu}
									fri={names.fri}
									sat={names.sat}
									sun={names.sun}
									handleUpdate={handleUpdate}
									errors={errors}
								/>
							)}

							<div className="msg-submit">
								{msg.type && <Msg data={msg} />}

								<div
									className={
										msg.type === "working" || msg.type === "success"
											? "hidden"
											: "submit-container"
									}
								>
									<Submit
										path="/registration"
										left="Back"
										submit="Submit Billing & Continue"
									/>
								</div>
							</div>
						</form>

						<div className="spacer"></div>
					</div>

					<div id="right-column">
						<Steps on={2} user={JSON.parse(getValFromLS("auth", true))} />
					</div>
				</>
			)}
		</>
	);
};

export default RegBilling;

function ticketAddonsQty(addons) {
	if (!addons) {
		return 0;
	}

	let qty = 0;
	addons.forEach((addon) => {
		if (addon.id === "tickets") {
			qty = qty + parseInt(addon.qty, 10);
		}
	});

	return qty;
}
